import { render, staticRenderFns } from "./selected.vue?vue&type=template&id=5ca7e9c3&scoped=true"
import script from "./selected.vue?vue&type=script&setup=true&lang=js"
export * from "./selected.vue?vue&type=script&setup=true&lang=js"
import style0 from "./selected.vue?vue&type=style&index=0&id=5ca7e9c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca7e9c3",
  null
  
)

export default component.exports